<template>
  <div class="recommend-container" v-if="data && data.length">
    <div class="title">您可能还想看</div>
    <div class="recommend-list">
      <div
        class="recommend-item"
        v-for="(item, index) in data"
        :key="index"
        @click.stop="bindJumpDetail(index)"
      >
        <div class="item-title">{{ item.title }}</div>
        <div class="item-info">
          <span>作者：{{ item.author_name }}</span>
          <span>{{ item.useful || 0 }}人觉得有用</span>
          <span>{{ item.save_num }}人收藏</span>
        </div>
        <div class="item-bottom">
          <div class="text" v-html="item.info"></div>
          <img class="banner" v-if="item.pics" :src="item.pics" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    bindJumpDetail(index) {
      this.$router.push({
        path: '/fatcamp/knowledge-base/words-detail',
        query: {
          id: this.data[index].id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.recommend-container {
  margin-top: 2.7vw;
  background: #fff;
  padding: 5.3vw;
  box-sizing: border-box;
  text-align: left;
  .title {
    font-size: 4vw;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.5);
    line-height: 5.6vw;
  }
  .recommend-item {
    padding: 3.7vw 0vw 8.8vw;
    border-bottom: 1px solid #f7f7f7;
    .item-title {
      font-size: 4.8vw;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000;
      line-height: 6.9vw;
      margin-bottom: 2.7vw;
    }
    .item-info {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 3.2vw;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 4.5vw;
      margin-bottom: 3.5vw;
      span {
        position: relative;
        display: inline-block;
        padding: 0vw 2.7vw;
      }
      span::after {
        position: absolute;
        content: '';
        width: 1px;
        height: 2.1vw;
        background-color: #979797;
        right: 0;
        top: 50%;
        transform: translate(0%, -50%);
      }
      span:first-child {
        padding-left: 0;
      }
      span:last-child {
        padding-right: 0;
      }
      span:last-child::after {
        display: none;
      }
    }
    .item-bottom {
      display: flex;
      align-items: center;
      .text {
        flex: 1;
        flex-shrink: 0;
        font-size: 3.2vw;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.7);
        line-height: 5.9vw;
        max-height: 17.7vw;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box; //将元素设为盒子伸缩模型显示
        -webkit-box-orient: vertical; //伸缩方向设为垂直方向
        -webkit-line-clamp: 3; //超出3行隐藏，并显示省略号
      }
      .banner {
        width: 16vw;
        height: 16vw;
        object-fit: cover;
        background: #e7e7e7;
        border-radius: 1.6vw;
        margin-left: 6.4vw;
      }
    }
  }
}
</style>
